import { render } from "./Gamification.vue?vue&type=template&id=32412c74"
import script from "./Gamification.vue?vue&type=script&lang=js"
export * from "./Gamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__